class RequisitionPerformanceReportController {
    /*@ngInject*/
    constructor($filter, $rootScope, $timeout, stateManagementStorageService, requisitionPerformanceReportService, jobService, companyService, candidateService, dateTimeUtilityService, utilityService, alertsAndNotificationsService) {
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.stateManagementStorageService = stateManagementStorageService;
        this.reportService = requisitionPerformanceReportService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.candidateService = candidateService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.utilityService = utilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.viewReportByFromState = "";
        this.savedFilters = null;
        this.companies = [];
        this.selectedCompanies = [];
        this.viewByOptions = [];
        this.selectedViewByOptions = [];
        this.clientOrBuList = [];
        this.selectedClientOrBuList = [];
        this.vendors = [];
        this.selectedVendors = [];
        this.roles = [];
        this.selectedRoles = [];
        this.workflowSteps = [];
        this.selectedWorkflowSteps = [];
        this.isHostCompany = this.companyService.isHostCompany();
        this.isCompaniesLoading = true;
        this.isClientsOrBusLoading = true;
        this.isVendorsLoading = true;
        this.isRolesLoading = true;
        this.isValidFilters = true;
        this.forInternalReport = false;
        this.showClickGetReportsMessage = false;
        this.showCorporateCandidates = false;
    }
    $onInit() {
        this.viewReportByFromState = this.viewReportBy;
        let savedFilters = this._getSavedFilters();
        if (savedFilters) {
            this.savedFilters = angular.copy(savedFilters);
            this.showCorporateCandidates = this.savedFilters.showCorporateCandidates == true;
        }
        this._setDateRangePicker(() => {
            this._initFiltersAndGetReports();
        });
    }
    resetFilters() {
        this.showCorporateCandidates = false;
        this._clearFilters();
        this._initFiltersAndGetReports();
    }
    _initFiltersAndGetReports() {
        this._setCompanyFilters();
        this._setReportLabelsByReportType();
        this._setGlobalFilters();
        this._setReportSections();
        this._setReasonCounts();
        if (this.isHostCompany) {
            this._getAllCompanies(() => {
                if (this.savedFilters !== null) {
                    this.selectedCompanyId = this.savedFilters.companyId;
                    this.selectedCompanyName = this.savedFilters.companyName;
                }
                else {
                    this.selectedCompanyId = this.selectedCompanies[0].id;
                    this.selectedCompanyName = this.selectedCompanies[0].name;
                }
                this._setViewByOptions(() => {
                    this.viewReportBy = this.selectedViewByOptions[0].id;
                    this._setReportLabelsByReportType();
                    this._getFilterValuesAndLoadReports(true);
                });
            });
        }
        else {
            this._clearFilters();
            this._getFilterValuesAndLoadReports(true);
        }
    }
    _getSavedFilters() {
        switch (this.viewReportByFromState) {
            case "all":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForAll');
                break;
            case "client":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForClient');
                break;
            case "internalRecruitment":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForInternalRecruitment');
                break;
            case "vendor":
                return this.stateManagementStorageService.getScreenState('requisitionPerformanceReportForVendor');
                break;
            default:
                break;
        }
    }
    _setDateRangePicker(successCallback) {
        let vm = this;
        let start = moment().startOf('week');
        let end = moment().endOf('week');
        if (this.savedFilters !== null) {
            start = moment(this.savedFilters.startDateTime);
            end = moment(this.savedFilters.endDateTime);
        }
        $(document).ready(() => {
            //for popover on table header
            $('[data-toggle="popover"]').popover();
            let startDateOfThisQuarter = moment().quarter(moment().quarter()).startOf('quarter');
            let endDateOfThisQuarter = moment().quarter(moment().quarter()).endOf('quarter');
            let startDateOfLastQuarter = moment(startDateOfThisQuarter).subtract(1, 'Q');
            let endDateOfLastQuarter = moment(endDateOfThisQuarter).subtract(1, 'Q');
            let startDateOfYear = moment().startOf('year');
            $('#report-range').daterangepicker({
                startDate: start,
                endDate: end,
                // showDropdowns: true,
                opens: "right",
                cancelButtonClasses: 'btn-danger',
                ranges: {
                    'This Week': [moment().startOf('week'), moment().endOf('week')],
                    'Last Week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'This Quarter': [startDateOfThisQuarter, endDateOfThisQuarter],
                    'Last Quarter': [startDateOfLastQuarter, endDateOfLastQuarter],
                    'Year to Date': [startDateOfYear, moment()]
                },
                locale: {
                    format: "MMMM DD, YYYY",
                    separator: " - "
                }
            }, onDateRangeChange);
            onDateRangeChange(start, end, true);
            this.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(start));
            this.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(end).setHours(23, 59, 59, 999));
            successCallback();
            function onDateRangeChange(start, end, init) {
                vm.onDateRangeChange(start, end, init);
            }
        });
    }
    onDateRangeChange(start, end, init) {
        $('#report-range span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        this.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(start));
        this.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(end).setHours(23, 59, 59, 999));
        if (init !== true) { //to avoid initial api call
            this.getFilterValues();
        }
    }
    _setCompanyFilters() {
        if (this.savedFilters) {
            this.isStaffingCompany = this.savedFilters.isStaffingCompany;
            this.viewReportBy = this.savedFilters.viewReportBy;
            this.selectedCompanyId = this.savedFilters.companyId;
            this.selectedCompanyName = this.savedFilters.companyName;
        }
        else {
            if (this.isHostCompany) {
                this.isStaffingCompany = true;
                this.viewReportBy = 'client';
            }
            else {
                this.isStaffingCompany = this.companyService.isStaffingCompany();
                this.selectedCompanyId = this.$rootScope.userDetails.company.companyId;
                this.selectedCompanyName = this.$rootScope.userDetails.company.companyName;
            }
        }
    }
    _setReportLabelsByReportType() {
        this.vendorsOrClientsOrBusLabel = "";
        if (this.viewReportBy == 'internalRecruitment') {
            this.vendorsOrClientsOrBusLabel = "BU";
            this.forInternalReport = true;
        }
        else if (this.viewReportBy == 'client') {
            this.vendorsOrClientsOrBusLabel = "Client";
            this.forInternalReport = true;
        }
        else if (this.viewReportBy == 'vendor') {
            this.vendorsOrClientsOrBusLabel = "Vendor";
            this.forInternalReport = false;
        }
        else {
            this.vendorsOrClientsOrBusLabel = "All";
        }
        this.reportDataTypes = ["All Data including Totals", "Only " + this.vendorsOrClientsOrBusLabel + " Totals"];
        this.selectedReportDataType = "All Data including Totals";
    }
    _setGlobalFilters() {
        this.reportPeriods = this.reportService.getReportPeriods();
        ;
        this.reportTypes = ["Graph", "Table"];
        if (this.savedFilters) {
            this.selectedReportType = this.savedFilters.selectedReportType;
            this.selectedReportDataType = this.savedFilters.selectedReportDataType;
        }
        else {
            this.selectedReportType = "Graph";
            this.selectedReportDataType = "All Data including Totals";
        }
    }
    _setReportSections() {
        this.reportSections = this.reportService.getReportSections();
    }
    _setReasonCounts() {
        let reasonCounts = [{ name: 'Top 10', value: '10', selected: true }, { name: 'All', value: 'all' }];
        this.releaseReasonCounts = angular.copy(reasonCounts);
        this.notInterestedReasonCounts = angular.copy(reasonCounts);
    }
    _getAllCompanies(successCallback) {
        if (this.isStaffingCompany) {
            this._getAllStaffingCompanies(() => {
                if (successCallback) {
                    successCallback();
                }
            });
        }
        else {
            this._getAllCorporateCompanies(() => {
                if (successCallback) {
                    successCallback();
                }
            });
        }
    }
    getFilterValues() {
        this._getAllClientsOrBus(() => {
            if (this.isStaffingCompany) {
                this._getAllRoles();
            }
            else if (this.viewReportBy === 'vendor') {
                this._getAllVendors(() => {
                    this._getAllRoles();
                }, true);
            }
            else {
                this._getAllRoles();
            }
        }, true);
    }
    _getFilterValuesAndLoadReports(isInit) {
        this._getAllClientsOrBus(() => {
            if (this.isStaffingCompany) {
                this._getAllRoles(() => {
                    this._getDataAndInitializeReports(isInit);
                }, true);
            }
            else if (this.viewReportBy === 'vendor') {
                this._getAllVendors(() => {
                    this._getAllRoles(() => {
                        this._getDataAndInitializeReports(isInit);
                    }, true);
                }, true);
            }
            else {
                this._getAllRoles(() => {
                    this._getDataAndInitializeReports(isInit);
                }, true);
            }
        }, true);
    }
    _getAllStaffingCompanies(successCallback) {
        this.isCompaniesLoading = true;
        let companiesFilter = {
            startDate: null,
            endDate: null
        };
        this.companyService.getAllStaffingCompaniesForReport(companiesFilter, (data) => {
            this._setCompanies(data);
            this.isCompaniesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getAllCorporateCompanies(successCallback) {
        this.isCompaniesLoading = true;
        let companiesFilter = {
            startDate: null,
            endDate: null
        };
        this.companyService.getAllCorporateCompaniesForReport(companiesFilter, (data) => {
            this._setCompanies(data);
            this.isCompaniesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setCompanies(companies) {
        this.companies = [];
        for (const companyId in companies) {
            this.companies.push({ id: companyId, name: companies[companyId], selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(companies[companyId]) });
        }
        let selectedCompany = this.companies[0];
        if (this.savedFilters !== null) {
            selectedCompany = this.companies.find(company => company.id == this.savedFilters.companyId);
        }
        selectedCompany.selected = true;
        this.selectedCompanies = [];
        this.selectedCompanies.push(selectedCompany);
    }
    _setViewByOptions(successCallback) {
        if (this.isStaffingCompany) {
            this.viewByOptions = [
                { id: 'client', name: 'Client' }
            ];
        }
        else {
            this.viewByOptions = [
                { id: 'vendor', name: 'Vendor' },
                { id: 'internalRecruitment', name: 'Internal Recruitment' }
            ];
        }
        this.selectedViewByOptions = [];
        let selectedViewByOption = this.viewByOptions[0];
        if (this.savedFilters !== null) {
            let selectedViewByOption = this.viewByOptions.find(option => option.id == this.savedFilters.viewReportBy);
        }
        selectedViewByOption.selected = true;
        this.selectedViewByOptions.push(selectedViewByOption);
        if (successCallback) {
            successCallback();
        }
    }
    _getAllClientsOrBus(successCallback, isInit) {
        this.isClientsOrBusLoading = true;
        let clientsOrBusFilter = {
            companyId: this.selectedCompanyId,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.companyService.getAllClientsOrBusByScope(clientsOrBusFilter, (data) => {
            this._setClientOrBuList(data, isInit);
            this.isClientsOrBusLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setClientOrBuList(clientsOrBus, isInit) {
        this.clientOrBuList = [];
        for (const clientOrBu of clientsOrBus) {
            let name = this._getFilterDisplayName(clientOrBu.name, clientOrBu.inCurrentScope, false);
            let displayName = this._getFilterDisplayName(clientOrBu.name, clientOrBu.inCurrentScope, true);
            this.clientOrBuList.push({ id: clientOrBu.id, name: name, selectedDisplayName: displayName, inCurrentScope: clientOrBu.inCurrentScope, unFormattedName: clientOrBu.name });
        }
        if (this.savedFilters !== null) {
            this.selectedClientOrBuList = this.clientOrBuList.filter(clientOrBu => this.savedFilters.clienOrBUIds.some(clientOrBuId => clientOrBuId == clientOrBu.id));
        }
        else {
            let alreadySelectedClientOrBuList = this.clientOrBuList.filter(clientOrBu => this.selectedClientOrBuList.some(selected => clientOrBu.id == selected.id));
            if (alreadySelectedClientOrBuList.length == 0) {
                this.selectedClientOrBuList = [...this.clientOrBuList];
            }
            else {
                this.selectedClientOrBuList = [...alreadySelectedClientOrBuList];
            }
        }
        for (let clientOrBu of this.selectedClientOrBuList) {
            clientOrBu.ticked = true;
        }
    }
    _getFilterDisplayName(name, inCurrentScope, withLengthFormatting) {
        let formattedName = "";
        if (withLengthFormatting) {
            if (name.length > 30) {
                formattedName = name.substring(0, 30) + "...";
            }
            else {
                formattedName = name;
            }
        }
        else {
            formattedName = name;
        }
        if (inCurrentScope) {
            return formattedName;
        }
        else {
            return '<span class="opacity-half">' + formattedName + '</span>';
        }
    }
    _getAllVendors(successCallback, isInit) {
        this.isVendorsLoading = true;
        let clientOrBuIds = this._getSelectedClientOrBuIds();
        let vendorsFilter = {
            buIds: clientOrBuIds,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.companyService.getAllVendorsByScope(vendorsFilter, this.selectedCompanyId, (data) => {
            this._setVendors(data, isInit);
            this.isVendorsLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getSelectedClientOrBuIds() {
        return this.selectedClientOrBuList.map(bu => {
            return bu.id;
        });
    }
    _setVendors(fetchedVendors, isInit) {
        this.vendors = [];
        for (const vendor of fetchedVendors) {
            let vendorObj = {
                id: vendor.id,
                name: vendor.name,
                selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(vendor.name),
                unFormattedName: vendor.name,
                buIds: vendor.buIds
            };
            this.vendors.push(vendorObj);
        }
        if (this.savedFilters !== null) {
            this.selectedVendors = this.vendors.filter(vendor => this.savedFilters.vendorIds.some(vendorId => vendorId == vendor.id));
        }
        else {
            let alreadySelectedVendors = this.vendors.filter(vendor => this.selectedVendors.some(selected => vendor.id == selected.id));
            if (alreadySelectedVendors.length == 0) {
                this.selectedVendors = [...this.vendors];
            }
            else {
                this.selectedVendors = [...alreadySelectedVendors];
            }
        }
        for (let vendor of this.selectedVendors) {
            vendor.ticked = true;
        }
    }
    _selectAllVendorsOfNewlySelectClientsOrBus() {
        this.clientOrBuList.forEach((clientOrBu) => {
            if (clientOrBu.ticked) {
                this.vendors.forEach(vendor => {
                    if (vendor.buIds.includes(clientOrBu.id)) {
                        vendor.ticked = true;
                        if (!this.selectedVendors.some(selectedVendor => selectedVendor.id === vendor.id)) {
                            this.selectedVendors.push(vendor);
                        }
                    }
                });
            }
        });
    }
    _getAllRoles(successCallback, isInit) {
        this.isRolesLoading = true;
        let clientOrBuIds = this._getSelectedClientOrBuIds();
        let vendorIds = this._getSelectedVendorIds();
        let filters = {
            companyId: this.selectedCompanyId,
            forInternalReport: this.forInternalReport,
            clientOrbuIds: clientOrBuIds,
            vendorIds: vendorIds,
            startDate: this.startDateTime,
            endDate: this.endDateTime
        };
        this.jobService.getAllJobsByScope(filters, (data) => {
            this.fetchedRoles = data;
            this._setRoles(data, isInit);
            this.savedFilters = null;
            this.isRolesLoading = false;
            if (successCallback) {
                successCallback();
            }
        }, error => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getSelectedVendorIds() {
        return this.selectedVendors.map(vendor => {
            return vendor.id;
        });
    }
    _setRoles(fetchedRoles, isInit) {
        let previousRoles = [...this.roles];
        this.roles = [];
        for (let role of fetchedRoles) {
            let name = this._getFilterDisplayName(role.requisitionNumber, role.inCurrentScope, false);
            let displayName = this._getFilterDisplayName(role.requisitionNumber + ' ' + role.roleName, role.inCurrentScope, true);
            let fullName = this._getFilterDisplayName(role.requisitionNumber + ' ' + role.roleName, role.inCurrentScope, false);
            let fullNameWithIcon = fullName;
            if (role.sharedRequisition) {
                fullNameWithIcon = `<i class="fas fa-share-alt"></i> ${fullNameWithIcon}`;
            }
            else {
                fullNameWithIcon = `&nbsp;&nbsp;&nbsp;&nbsp;${fullNameWithIcon}`;
            }
            let icon = role.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '';
            let roleObj = {
                id: role.id,
                name: name,
                displayName: displayName,
                icon: icon,
                selectedDisplayName: displayName,
                fullName: fullName,
                fullNameWithIcon: fullNameWithIcon,
                inCurrentScope: role.inCurrentScope,
                unFormattedName: role.requisitionNumber,
                clientOrBuId: role.clientOrBuId,
                vendorId: role.vendorId
            };
            this.roles.push(roleObj);
        }
        if (this.savedFilters !== null) {
            this.selectedRoles = this.roles.filter(role => this.savedFilters.roles.some(roleId => roleId == role.id));
        }
        else {
            let alreadySelectedRoles = this.roles.filter(role => this.selectedRoles.some(selected => role.id == selected.id));
            if (this._hasNoRolesBeenSelectedPreviously(alreadySelectedRoles) || this._hasAllRolesBeenSelectedPreviouslyAndNewRolesAreToBeSelected(alreadySelectedRoles, previousRoles)) {
                this.selectedRoles = [...this.roles];
                this.onRoleChange();
            }
            else {
                if (this.selectedRoles.length !== alreadySelectedRoles.length) {
                    this.onRoleChange();
                }
                this.selectedRoles = [...alreadySelectedRoles];
            }
        }
        for (let role of this.selectedRoles) {
            role.ticked = true;
        }
    }
    _hasNoRolesBeenSelectedPreviously(alreadySelectedRoles) {
        return alreadySelectedRoles.length == 0;
    }
    _hasAllRolesBeenSelectedPreviouslyAndNewRolesAreToBeSelected(alreadySelectedRoles, previousRoles) {
        return alreadySelectedRoles.length == previousRoles.length && this.roles.length > alreadySelectedRoles.length;
    }
    _selectAllRolesOfNewlySelectedClientsOrBusAndVendors() {
        this.clientOrBuList.forEach((clientOrBu) => {
            if (clientOrBu.ticked) {
                this.vendors.forEach(vendor => {
                    if (vendor.ticked && !this.selectedRoles.some(role => role.clientOrBuId === clientOrBu.id && role.vendorId === vendor.id)) {
                        this.roles.forEach(role => {
                            if (role.clientOrBuId == clientOrBu.id && role.vendorId == vendor.id) {
                                role.ticked = true;
                                this.selectedRoles.push(role);
                            }
                        });
                    }
                });
            }
        });
    }
    _selectAllRolesOfNewlySelectedClientsOrBus() {
        this.clientOrBuList.forEach((clientOrBu) => {
            if (clientOrBu.ticked && !this.selectedRoles.some(role => role.clientOrBuId === clientOrBu.id)) {
                this.roles.forEach(role => {
                    if (role.clientOrBuId == clientOrBu.id) {
                        role.ticked = true;
                        this.selectedRoles.push(role);
                    }
                });
            }
        });
    }
    getReportsAndSetReports() {
        this._getReportData(() => {
            $(document).ready(() => {
                this._initializeTables();
                this._setWorkflowStepsVisibilityFilter();
                this._setGraphs();
            });
        });
    }
    _getDataAndInitializeReports(isInit) {
        this._getReportData(() => {
            $(document).ready(() => {
                this._initializeTables(isInit);
                this._setWorkflowStepsVisibilityFilter();
                this._setGraphs();
            });
        });
    }
    _getReportData(successCallback) {
        this.showClickGetReportsMessage = false;
        this.reportSections.forEach(section => {
            section.isGraphLoading = true;
        });
        let clientOrBuIds = this._getSelectedClientOrBuIds();
        let vendorIds = this._getSelectedVendorIds();
        let roleIds = this._getSelectedRoleIds();
        if (roleIds.length == 0 || this.viewReportBy == 'all') {
            this.isValidFilters = false;
            this.invalidFiltersMessage = "Please select roles to filter";
        }
        else {
            this.utilityService.showLoadingModal("Loading Reports");
            this.isValidFilters = true;
            let filters = {
                companyId: this.selectedCompanyId,
                companyName: this.selectedCompanyName,
                roles: roleIds,
                clienOrBUIds: clientOrBuIds,
                startDateTime: this.startDateTime,
                endDateTime: this.endDateTime,
                forInternalReport: this.forInternalReport,
                vendorIds: vendorIds,
                jobByScopeResponseDTOs: this.fetchedRoles,
                //for saving filters
                isStaffingCompany: this.isStaffingCompany,
                selectedReportType: this.selectedReportType,
                selectedReportDataType: this.selectedReportDataType,
                viewReportBy: this.viewReportBy,
                showCorporateCandidates: this.showCorporateCandidates
            };
            this._setSavedFilters(filters);
            this.companyService.getCompanyReports(filters, (data) => {
                // data = this.reportService.getDummyData();
                this._massageReportData(data);
                this.utilityService.hideLoadingModal();
                if (successCallback) {
                    successCallback();
                }
            }, error => {
                if (this.$rootScope.isOnline) {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            });
        }
    }
    _setSavedFilters(filters) {
        switch (this.viewReportByFromState) {
            case "all":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForAll', filters);
                break;
            case "client":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForClient', filters);
                break;
            case "internalRecruitment":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForInternalRecruitment', filters);
                break;
            case "vendor":
                this.stateManagementStorageService.setScreenState('requisitionPerformanceReportForVendor', filters);
                break;
            default:
                break;
        }
    }
    _massageReportData(fetchedData) {
        this.reportData = this.reportService.getMassagedReportData(fetchedData, this.viewReportBy, this.selectedCompanyName);
    }
    _getSelectedRoleIds() {
        return this.selectedRoles.map(role => {
            return role.id;
        });
    }
    //Table
    _setWorkflowStepsVisibilityFilter() {
        this.workflowSteps = [
            { name: "Recruiter Screening", fields: ["inRecruiterScreening", "recruiterScreeningSkipped", "recruiterScreeningDone", "recruiterScreeningPassed", "recruiterScreeningFailed"], ticked: true },
            { name: "Tech Assessment", fields: ["techAssessmentCancelled", "techAssessmentSent", "techAssessmentTestLeft", "techAssessmentExpired", "techAssessmentNotYetSend", "techAssessmentSendFailed", "techAssessmentSuspended", "techAssessmentTerminated", "inTechAssessment", "attemptedCandidatesCount", "techAssessmentAttemptCount", "techAssessmentSkipped", "techAssessmentDone", "techAssessmentPassed", "techAssessmentFailed", "techAssessmentCompleted"], ticked: true },
            { name: "Value Assessment", fields: ["inValueAssessment", "valueAssessmentSkipped", "valueAssessmentDone", "valueAssessmentPassed", "valueAssessmentFailed"], ticked: true },
            { name: "Phone Screen", fields: ["inPhoneScreen", "phoneScreenSkipped", "phoneScreenScheduled", "phoneScreenDone", "phoneScreenPassed", "phoneScreenFailed"], ticked: true },
            { name: "Interview", fields: ["inInterview", "interviewScheduled", "interviewDone", "interviewPassed", "interviewFailed"], ticked: true },
            { name: "Filled", fields: ["filled"], ticked: true },
            { name: "Hired", fields: ["hired"], ticked: true },
            { name: "Released", fields: ["released"], ticked: true },
            { name: "Not Interested", fields: ["notInterested"], ticked: true }
        ];
    }
    _initializeTables(isInit) {
        angular.forEach(this.reportSections, (section, key) => {
            this._initializeTable(section.sectionNumber, isInit);
        });
    }
    _initializeTable(sectionNumber, isInit) {
        let reportData = angular.copy(this.reportData);
        let isAllData = true;
        if (this.selectedReportDataType !== "All Data including Totals") {
            if (this.showCorporateCandidates) {
                reportData.table = angular.copy(this.reportData.table.withoutTotalWithCorporateCandidates);
            }
            else {
                reportData.table = angular.copy(this.reportData.table.withoutTotal);
            }
            isAllData = false;
        }
        else if (this.showCorporateCandidates) {
            reportData.table = angular.copy(this.reportData.table.withCorporateCandidates);
        }
        if (isInit || Object.keys(this.reportSections[sectionNumber].table).length === 0) {
            let gridOptions = this.reportService.getGridOptions(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData, this.clientOrBuList);
            this.reportSections[sectionNumber].table.gridOptions = gridOptions.gridOptions;
            this.reportSections[sectionNumber].table.gridOptionsFooter = gridOptions.gridOptionsFooter;
            console.log("initialize report");
            this.reportSections[sectionNumber].isTableLoading = false;
        }
        else {
            let gridId = '#grid-' + sectionNumber;
            let rowData = this.reportService.getRowData(sectionNumber, reportData);
            let footerRowData = this.reportService.getFooterRowData(sectionNumber, reportData, isAllData);
            let columnDefs = this.reportService.getColumnDefs(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData);
            this.reportSections[sectionNumber].table.gridOptions.api.setRowData(rowData);
            this.reportSections[sectionNumber].table.gridOptions.api.setPinnedBottomRowData(footerRowData);
            this.reportSections[sectionNumber].table.gridOptions.api.setColumnDefs(columnDefs);
            if (rowData.length < 10) {
                this.reportSections[sectionNumber].table.gridOptions.api.setDomLayout('autoHeight');
                document.querySelector(gridId).style.height = '';
            }
            else {
                this.reportSections[sectionNumber].table.gridOptions.api.setDomLayout('normal');
                // when auto height is off, the grid ahs a fixed height, and then the grid
                // will provide scrollbars if the data does not fit into it.
                document.querySelector(gridId).style.height = '400px';
            }
        }
    }
    getTableHeight(reportSection) {
        let tableName = reportSection.name;
        if (reportSection.table.gridOptions.rowData.length < 10) {
            return {};
        }
        // if(tableName === 'Tech Assessments Scores'){
        //     return { "height": "400px", "width": "90%" };
        // } else {
        return { "height": "400px", "width": "100%" };
        // }
        // if(tableName == 'Workflow Steps') {
        // } else if(tableName == 'Job Matches Scores') {
        //     return { "height": "400px", "width": "90%" };
        // } else {
        //     return { "height": "400px", "width": "80%" };
        // }
    }
    autoSizeAll(sectionNumber, skipHeader) {
        let section = this.reportSections[sectionNumber];
        let allColumnIds = [];
        console.log(section.table.gridOptions);
        if (!_.isEmpty(section.table)) {
            section.table.gridOptions.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.colId);
            });
            section.table.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
        }
    }
    onFirstDataRendered() {
        angular.forEach(this.reportSections, (section, key) => {
            let allColumnIds = [];
            console.log(section.table.gridOptions);
            if (!_.isEmpty(section.table)) {
                section.table.gridOptions.columnApi.getAllColumns().forEach((column) => {
                    allColumnIds.push(column.colId);
                });
                section.table.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
            }
        });
    }
    onWorkflowStepClick() {
        angular.forEach(this.workflowSteps, (step, key) => {
            angular.forEach(step.fields, (field, index) => {
                this.reportSections[0].table.gridOptions.columnApi.setColumnVisible(field, step.ticked);
            });
        });
    }
    //Set Graphs
    _setGraphs() {
        angular.forEach(this.reportSections, (section, key) => {
            this._setGraph(section.sectionNumber);
            section.isGraphLoading = false;
            angular.forEach(section.subSections, (subSec, key) => {
                this._setGraph(subSec.sectionNumber);
                subSec.isGraphLoading = false;
            });
        });
    }
    _setGraph(sectionNumber) {
        let graphData = this.showCorporateCandidates ? this.reportData.graph.withCorporate : this.reportData.graph;
        let graphSettings = this.reportService.getGraphSettings(sectionNumber, graphData);
        if (sectionNumber < 5) {
            this.reportSections[sectionNumber].graph.labels = graphSettings.labels;
            this.reportSections[sectionNumber].graph.data = graphSettings.data;
            this.reportSections[sectionNumber].graph.options = graphSettings.options;
            this.reportSections[sectionNumber].graph.series = graphSettings.series;
            this.reportSections[sectionNumber].graph.colors = graphSettings.colors;
        }
        else if (sectionNumber == 5) {
            this.reportSections[3].subSections[0].graph.labels = graphSettings.labels;
            this.reportSections[3].subSections[0].graph.data = graphSettings.data;
            this.reportSections[3].subSections[0].graph.options = graphSettings.options;
            this.reportSections[3].subSections[0].graph.series = graphSettings.series;
            this.reportSections[3].subSections[0].graph.colors = graphSettings.colors;
        }
        else if (sectionNumber == 6) {
            this.reportSections[4].subSections[0].graph.labels = graphSettings.labels;
            this.reportSections[4].subSections[0].graph.data = graphSettings.data;
            this.reportSections[4].subSections[0].graph.options = graphSettings.options;
            this.reportSections[4].subSections[0].graph.series = graphSettings.series;
            this.reportSections[4].subSections[0].graph.colors = graphSettings.colors;
        }
    }
    toggleCompanyType(isStaffingCompany) {
        this.isStaffingCompany = isStaffingCompany;
        this._getAllCompanies(() => {
            this.selectedCompanyId = this.selectedCompanies[0].id;
            this.selectedCompanyName = this.selectedCompanies[0].name;
            this._setViewByOptions(() => {
                this.viewReportBy = this.selectedViewByOptions[0].id;
                this._setReportLabelsByReportType();
                this._clearFilters();
                this.getFilterValues(false);
            });
        });
    }
    onCompanySelected() {
        if (this.selectedCompanies.length > 0) {
            this.selectedCompanyId = this.selectedCompanies[0].id;
            this.selectedCompanyName = this.selectedCompanies[0].name;
            this._clearFilters();
            this.getFilterValues();
        }
        else {
            this.selectedCompanyId = null;
            this.selectedCompanyName = null;
        }
    }
    _clearFilters() {
        this.clientOrBuList = [];
        this.selectedClientOrBuList = [];
        this.vendors = [];
        this.selectedVendors = [];
        this.roles = [];
        this.selectedRoles = [];
    }
    onViewBySelected() {
        this.viewReportBy = this.selectedViewByOptions[0].id;
        this._setReportLabelsByReportType();
        this._clearFilters();
        this.getFilterValues();
    }
    toggleReportType(reportType) {
        this.selectedReportType = reportType;
        if (reportType == "Graph") {
            this.$timeout(() => {
                this._setGraphs();
            }, 100);
        }
    }
    toggleReportDataType(reportDataType) {
        this.selectedReportDataType = reportDataType;
        this._setWorkflowStepsVisibilityFilter();
        this._initializeTables();
    }
    toggleShowCorporateCandidates() {
        if (this.savedFilters !== null) {
            this.savedFilter.showCorporateCandidates = this.showCorporateCandidates;
        }
        this.$timeout(() => {
            this._setWorkflowStepsVisibilityFilter();
            this._initializeTables();
            this._setGraphs();
        }, 100);
    }
    selectRemoveAll(filterName, action) {
        if (action == 'selectAll') {
            switch (filterName) {
                case 'clientsOrBus':
                    this.selectedClientOrBuList = [...this.clientOrBuList];
                    this.selectedClientOrBuList.forEach(clientOrBu => {
                        clientOrBu.ticked = true;
                    });
                    this.onClientOrBuChange();
                    break;
                case 'vendors':
                    this.selectedVendors = [...this.vendors];
                    this.selectedVendors.forEach(vendor => {
                        vendor.ticked = true;
                    });
                    this.onVendorChange();
                    break;
                case 'roles':
                    this.selectedRoles = [...this.roles];
                    this.selectedRoles.forEach(role => {
                        role.ticked = true;
                    });
                    this.onRoleChange();
                    break;
                default:
                    //do nothing
                    break;
            }
        }
        else if (action == 'removeAll') {
            switch (filterName) {
                case 'clientsOrBus':
                    this.selectedClientOrBuList = [];
                    this.onClientOrBuChange();
                    break;
                case 'vendors':
                    this.selectedVendors = [];
                    this.onVendorChange();
                    break;
                case 'roles':
                    this.selectedRoles = [];
                    this.onRoleChange();
                    break;
                default:
                    //do nothing
                    break;
            }
        }
    }
    onClientOrBuChange() {
        if (this.isStaffingCompany) {
            this._getAllRoles();
        }
        else if (this.viewReportBy === 'vendor') {
            this._getAllVendors(() => {
                this._getAllRoles();
            });
        }
        else {
            this._getAllRoles();
        }
    }
    onVendorChange() {
        this._getAllRoles();
    }
    onRoleChange() {
        this.showClickGetReportsMessage = true;
    }
    resetTable(sectionNumber) {
        let section = this.reportSections[sectionNumber];
        if (sectionNumber == 0) {
            this._setWorkflowStepsVisibilityFilter();
        }
        let reportData = angular.copy(this.reportData);
        let isAllData = true;
        if (this.selectedReportDataType !== "All Data including Totals") {
            if (this.showCorporateCandidates) {
                reportData.table = angular.copy(this.reportData.table.withoutTotalWithCorporateCandidates);
            }
            else {
                reportData.table = angular.copy(this.reportData.table.withoutTotal);
            }
        }
        else if (this.showCorporateCandidates) {
            reportData.table = angular.copy(this.reportData.table.withCorporateCandidates);
        }
        let columnDefs = this.reportService.getColumnDefs(sectionNumber, this.vendorsOrClientsOrBusLabel, reportData, isAllData);
        section.table.gridOptions.api.setColumnDefs(columnDefs);
        // section.table.gridOptions.columnApi.resetColumnState();
    }
    $onDestroy() {
    }
}
RequisitionPerformanceReportController.$inject = ['$filter', '$rootScope', '$timeout', 'stateManagementStorageService', 'requisitionPerformanceReportService', 'jobService', 'companyService', 'candidateService', 'dateTimeUtilityService', 'utilityService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './requisition-performance-report.html';
import * as TEMPLATE from 'raw-loader!./requisition-performance-report.html';
export const RequisitionPerformanceReportComponent = {
    selector: 'requisitionPerformanceReport',
    component: {
        bindings: {
            viewReportBy: '<'
        },
        controller: RequisitionPerformanceReportController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/reports/requisitionPerformanceReport/requisitionPerformanceReport/requisition-performance-report.html'
    }
};
//# sourceMappingURL=requisition-performance-report.component.js.map